<template>
  <div>
    <div class="policy_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <p class="mobitxt">
            Tämä tietosuojakäytäntö on laadittu palvelemaan paremmin niitä,
            jotka ovat kiinnostuneita siitä, miten heidän henkilökohtaisesti
            tunnistettavia tietojaan (PII) käytetään verkossa. Lue
            tietosuojakäytäntömme huolellisesti saadaksesi selkeän käsityksen
            siitä, miten keräämme, käytämme, suojaamme tai muuten käsittelemme
            henkilötietojasi verkkosivustomme mukaisesti.
          </p>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Mitä henkilökohtaisia ​​tietoja keräämme ihmisiltä, ​​jotka
              vierailevat blogissamme, verkkosivustollamme tai sovelluksessamme?
            </h2>
            <p class="mobitxt">
              Kun tilaat tai rekisteröidyt sivustollemme, sinua saatetaan
              tarvittaessa pyytää antamaan nimesi, sähköpostiosoitteesi,
              postiosoitteesi, puhelinnumerosi tai muita tietojasi kokemuksen
              parantamiseksi.
            </p>
          </div>

          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Milloin keräämme tietoja?
            </h2>
            <p class="mobitxt">
              Keräämme tietoja sinulta, kun rekisteröidyt sivustollemme, täytät
              lomakkeen tai syötät tietoja sivustollemme. Anna meille palautetta
              tuotteistamme tai palveluistamme.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Kuinka käytämme tietojasi?
            </h2>
            <p class="mobitxt">
              Voimme käyttää sinulta keräämäämme tietoja, kun rekisteröidyt,
              ostat, ilmoitat uutiskirjeemme, vastaat kyselyyn tai
              markkinointiviestintään, surffailemme verkkosivustolla tai
              käytämme tiettyjä muita sivuston ominaisuuksia seuraavilla
              tavoilla:
            </p>
            <ul>
              <li>
                Voit mukauttaa kokemustasi ja antaa meille mahdollisuuden
                toimittaa sinua kiinnostavinta sisältö- ja tuotetyyppiä.
              </li>
              <li>Parantaa verkkosivustoamme palvelemaan sinua paremmin.</li>
              <li>
                Jotta voimme palvella sinua paremmin vastaamalla
                asiakaspalvelupyyntöihisi
              </li>
              <li>
                Kilpailun, kampanjan, kyselyn tai muun sivuston ominaisuuden
                hallinnoiminen.
              </li>
              <li>Tapahtumien nopea käsittelys.</li>
              <li>
                Pyydä luokituksia ja arvosteluja palveluista tai tuotteista
              </li>
            </ul>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Kuinka suojaamme tietojasi?
            </h2>
            <p class="mobitxt">
              Verkkosivustomme tarkistetaan säännöllisesti tietoturva-aukkojen
              ja tunnettujen haavoittuvuuksien varalta, jotta vierailustasi
              sivustollemme tulisi mahdollisimman turvallista.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Käytämmekö evästeitä?</h2>
            <p class="mobitxt">
              Joo. Evästeet ovat pieniä tiedostoja, jotka sivusto tai sen
              palveluntarjoaja siirtää tietokoneen kiintolevylle verkkoselaimesi
              kautta (jos sallit), jonka avulla sivuston tai palveluntarjoajan
              järjestelmät voivat tunnistaa selaimesi ja siepata ja muistaa
              tiettyjä tietoja. Esimerkiksi käytämme evästeitä auttaaksemme
              meitä muistamaan ja käsittelemään ostoskorissasi olevat tuotteet.
              Niitä käytetään myös auttamaan meitä ymmärtämään asetuksesi
              aiemman tai nykyisen sivuston toiminnan perusteella, mikä antaa
              meille mahdollisuuden tarjota sinulle parempia palveluja. Käytämme
              myös evästeitä auttaaksemme meitä keräämään koottuja tietoja
              sivuston liikenteestä ja sivuston vuorovaikutuksesta, jotta voimme
              tarjota parempia sivustokokemuksia ja työkaluja tulevaisuudessa.
            </p>
            <p class="mobitxt">Käytämme evästeitä:</p>
            <ul>
              <li>
                Ymmärrä ja tallenna käyttäjän asetukset tulevia vierailuja
                varten.
              </li>
              <li>Seuraa mainoksia.</li>
              <li>
                Kerää koottuja tietoja sivuston liikenteestä ja sivuston
                vuorovaikutuksesta tarjotaksesi parempia sivustokokemuksia ja
                työkaluja tulevaisuudessa. Voimme käyttää myös luotettavia
                kolmannen osapuolen palveluja, jotka seuraavat näitä tietoja
                puolestamme.
              </li>
            </ul>
            <p class="mobitxt">
              Voit halutessasi pyytää tietokonettasi varoittamaan sinua aina,
              kun eväste lähetetään, tai voit poistaa kaikki evästeet käytöstä.
              Teet tämän selaimesi asetusten kautta. Koska selain on hieman
              erilainen, katso selaimesi Ohje-valikosta oppiaksesi oikea tapa
              muokata evästeitä.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Kolmannen osapuolen paljastaminen
            </h2>
            <p class="mobitxt">
              Emme myy, vaihda tai muuten välitä henkilötietojasi ulkopuolisille
              osapuolille, ellemme ilmoita asiasta käyttäjille etukäteen. Tämä
              ei sisällä verkkosivustojen isännöintikumppaneita eikä muita
              osapuolia, jotka auttavat meitä verkkosivustomme toiminnassa,
              liiketoiminnassamme tai palvelemisessa käyttäjillemme, kunhan
              osapuolet sitoutuvat pitämään nämä tiedot luottamuksellisina.
              Voimme myös julkaista tietoja, kun niiden julkaisu on
              tarkoituksenmukaista lain noudattamiseksi, sivustokäytäntöjemme
              noudattamiseksi tai omien tai muiden oikeuksien, omaisuuden
              suojaamiseksi
            </p>
            <p class="mobitxt">
              Henkilökohtaisesti tunnistamatonta vierailijatietoa voidaan
              kuitenkin antaa muille osapuolille markkinointia, mainontaa tai
              muuta käyttöä varten.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Kolmannen osapuolen linkit
            </h2>
            <p class="mobitxt">
              Emme sisälly tai tarjoa kolmannen osapuolen tuotteita tai
              palveluja verkkosivustollamme.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Google</h2>
            <p class="mobitxt">
              Googlen mainontavaatimukset voidaan tiivistää Googlen
              mainontaperiaatteilla. Ne perustetaan tarjoamaan käyttäjille
              positiivinen kokemus.
              <a
                href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
                >Napsauta tätä nähdäksesi</a
              >
            </p>
            <p class="mobitxt">
              Google käyttää kolmannen osapuolen toimittajina evästeitä
              mainosten näyttämiseen sivustollamme. Googlen DART-evästeen käyttö
              antaa sen näyttää mainoksia käyttäjillemme aiempien vierailujen
              perusteella sivustollamme ja muilla Internet-sivustoilla.
              Käyttäjät voivat kieltäytyä DART-evästeen käytöstä vierailemalla
              Googlen mainos- ja sisältöverkoston tietosuojakäytännössä.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Olemme toteuttaneet seuraavat:
            </h2>
            <p class="mobitxt">
              Me yhdessä kolmansien osapuolten toimittajien, kuten Google,
              kanssa käytämme ensimmäisen osapuolen evästeitä (kuten Google
              Analytics -evästeitä) ja kolmannen osapuolen evästeitä (kuten
              DoubleClick -eväste) tai muita kolmannen osapuolen tunnisteita
              keräämään tietoja käyttäjien vuorovaikutuksesta käyttäjien kanssa.
              mainosten näyttökerrat ja muut mainospalvelutoiminnot, jotka
              liittyvät verkkosivustoomme.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">Kieltäytyminen:</h2>
            <p class="mobitxt">
              Käyttäjät voivat asettaa asetuksia sille, miten Google mainostaa
              sinulle, käyttämällä Google-mainosasetussivua. Vaihtoehtoisesti
              voit kieltäytyä käymällä Network Advertising Initiative Opt Out
              -sivulla tai käyttämällä Google Analytics Opt Out Browser
              -lisäosaa.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm privacy_color">
              Sallitseeko sivustomme kolmannen osapuolen käyttäytymisen
              seurannan?
            </h2>
            <p class="mobitxt">
              On myös tärkeää huomata, että sallimme kolmannen osapuolen
              käyttäytymisen seurannan
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: mapGetters(["host_gamebox", "countryCode"]),
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/gamebox/PrivacyPolicyFinnish.vue